function initAnnouncementSlider() {
  if (!window.announcementSettings) return;

  var swiper = new Swiper(".M-announcement-slider", {
    autoplay: {
      delay: window.announcementSettings.autoSpeed, 
    },
    speed: window.announcementSettings.dragSpeed,
    loop: true,
    slidesPerView: 1,
  });
}

function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 15,
    slidesPerView: 3,
    speed: 400,
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
    breakpoints: {
      348: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {

  const numberEl = document.getElementById('uinventory-new-number');
  if (!numberEl || !window.uInventoryConfig) return;

  const blockId = Object.keys(window.uInventoryConfig)[0];
  const { min, max } = window.uInventoryConfig[blockId];

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getCurrentVariantId() {
    const variantInput = document.querySelector('[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function updateInventoryNumber() {
    const variantId = getCurrentVariantId();
    if (!variantId) return;

    const storageKey = `uinventory_${blockId}_${variantId}`;
    let value = localStorage.getItem(storageKey);

    if (!value) {
      value = getRandom(min, max);
      localStorage.setItem(storageKey, value);
    }

    numberEl.textContent = value;
  }

  // Initial load
  updateInventoryNumber();

  // Variant change (buttons, dropdowns, swatches)
  document.addEventListener('change', function (e) {
    if (
      e.target.name === 'id' ||
      e.target.closest('[data-variant-id]') ||
      e.target.closest('.variant-input')
    ) {
      updateInventoryNumber();
    }
  });

  // Support for themes that trigger custom variant events
  document.addEventListener('variant:change', updateInventoryNumber);
});